import { component } from 'picoapp';

export default component(async (node) => {
  const initWrapTables = () => {
    const tables = node.querySelectorAll('table');

    tables.forEach((table) => {
      const wrapper = document.createElement('DIV');
      wrapper.classList.add('overflow-auto', 'scrollbar');

      table.replaceWith(wrapper);
      wrapper.appendChild(table);
    });
  };

  initWrapTables();
});
